export const DATE_ATTRIBUTES = [
  'start_at',
  'created',
  'updated',
  'end_at',
  'date',
  'open_since',
]

export const FILTER_SEPARATORS = {
  DATE: ' - ',
  DEFAULT: ', ',
  NONE: '',
  NUMERIC: ' - ',
}

export const RENTALS_DEVICE_CATEGORY_ATTRIBUTE =
  'rental.stocklist_item.product_type'

export const RENTALS_DEVICE_CATEGORY_CORE_VALUES = new Set([
  'smartphone',
  'tablet',
  'laptop',
])
